export class VideoProviderEdit
{
    public id = null;
    public name = '';
    public active = true;
    public url = '';
}

export interface VideoProviderList
{
    id: number;
    name: string;
    active: boolean;
    lastModifiedBy: string;
    lastModifiedDate: Date;
}
